/* RESPONSIBLE TEAM: team-ai-agent */
import ApplicationSerializer from '../application';

export default class EscalationPredicatesSerializer extends ApplicationSerializer {
  serialize(snapshot: any) {
    let predicateGroup = snapshot.attr('predicateGroup');
    return {
      predicate_group: predicateGroup?.serialize() || { predicates: [] },
    };
  }

  keyForAttribute(attr: string): string {
    if (attr === 'predicateGroup') {
      return 'predicateGroup';
    }
    return super.keyForAttribute(attr);
  }

  normalize(modelClass: any, resourceHash: any) {
    if (resourceHash.predicate_group !== undefined) {
      resourceHash.predicateGroup = resourceHash.predicate_group;
      delete resourceHash.predicate_group;
    }

    return super.normalize(modelClass, resourceHash);
  }
}
